import(/* webpackMode: "eager" */ "/app/src/app/[locale]/terms-conditions/layout.tsx");
